import React, { Component } from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, InputNumber, Select, DatePicker } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogosRequest from '../../services/Catalogos';
import SitiosRequest from '../../services/Sitios';
import moment from 'moment'
import 'moment/locale/es';
moment.locale('es')

const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const dateFormatRange = 'YYYY/MM/DD';
const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de mostrar form de productos
 */
class FormEstatusProductos extends Component {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrPorcentajes: [],
        detalleSitio: undefined,
        rangoIncremento: [],
        numero_maximo_entrega: 1,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrEstatus: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: [],
        mostrarPromocion: false,
        mostrarNuevo: false,
    }

    /**
     * Función que se ejecuta cuando se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        let porcentajes = [
            { id: 0, nombre: "0%" }, { id: 10, nombre: "10%" }, { id: 20, nombre: "20%" },
            { id: 30, nombre: "30%" }, { id: 40, nombre: "40%" }, { id: 50, nombre: "50%" },
            { id: 60, nombre: "60%" }, { id: 70, nombre: "70%" }, { id: 80, nombre: "80%" },
            { id: 90, nombre: "90%" }, { id: 100, nombre: "100%" }, { id: 110, nombre: "110%" },
            { id: 120, nombre: "120%" }, { id: 130, nombre: "130%" }, { id: 140, nombre: "140%" },
            { id: 150, nombre: "150%" }, { id: 160, nombre: "160%" }, { id: 170, nombre: "170%" },
            { id: 180, nombre: "180%" }, { id: 190, nombre: "190%" }, { id: 200, nombre: "200%" },
        ]

        state.arrPorcentajes = porcentajes
        this.setState(state)
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if ((this.props.arrArticulos !== prevProps.arrArticulos)) {
            if (!state.arrEstatus.length) {
                this.setState({ cargando: true }, () => {
                    CatalogosRequest.ListarEstatus().then(response => {
                        state.arrEstatus = response.data
                        state.cargando = false;
                        this.setState(state)
                    }).catch(err => {
                        openNotification(
                            "No se han podido listar los estatus.",
                            "Error al listar estatus",
                            false
                        )
                    })
                })
            }
        }

        if ((this.props.producto_selected !== prevProps.producto_selected)) {
            if (this.props.modo === "uno") {
                if (this.props.producto_selected !== null) {
                    state.mostrarPromocion = false;
                    state.mostrarNuevo = false
                    if (this.props.producto_selected.estatus === 4) {
                        state.mostrarPromocion = true
                    }

                    if (this.props.producto_selected.estatus === 3) {
                        state.mostrarNuevo = true
                    }
                }

                this.setState(state)
                if (!state.arrEstatus.length) {
                    this.setState(state, () => {
                        CatalogosRequest.ListarEstatus().then(response => {
                            state.arrEstatus = response.data
                            state.cargando = false;
                            this.setState(state)
                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification(
                                "No se han podido listar los estatus.",
                                "Error al listar estatus",
                                false
                            )
                        })
                    })
                }
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            mostrarNuevo: false,
            mostrarPromocion: false,
            regionSelected: null,
            sucursalSelected: null,
            plazaSelected: null,
            drivesSelected: [],
        })
    }

    /**
     * Función que se ejecuta cuando se confirma edición de estatus
     * @param: e. valor para prevent
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: this.props.arrArticulos.length === 1 ? <div><b>¿Está seguro de editar el estatus?</b> Se cambiará la información del artículo seleccionado.</div> : <div><b>¿Está seguro de editar el estatus?</b> Se cambiará la información de los artículos seleccionados.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-estatus-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-estatus-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarEstatusProductos)
                    },
                });
            }
        });
    }

    /**
     * Función que se cambia el estaus
     * @param: value. valor del id del estatus
     * @return: nada.
     */
    handleChangeEstatus = (value) => {
        let state = { ...this.state }
        const { setFieldsValue } = this.props.form
        state.mostrarPromocion = false
        state.mostrarNuevo = false

        if (value === 4) {
            state.mostrarPromocion = true
        }

        if (value === 3) {
            state.mostrarNuevo = true
        }

        setFieldsValue({
            incremento_eventualidad: null,
            rango_incremento: [],
            dia1: null, dia2: null, dia3: null, dia4: null, dia5: null, dia7: null,
            dia8: null, dia9: null, dia10: null, dia11: null, dia12: null, dia13: null,
            dia14: null, dia15: null, dia16: null, dia17: null, dia18: null, dia19: null,
            dia6: null, dia20: null, dia21: null
        })

        this.setState(state)
    }

    /**
     * Función que se cambia el estatus de los productos
     * @param: nada.
     * @return: nada.
     */
    editarEstatusProductos = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let objEnviar = {};
                objEnviar.estatus = values.estatus
                objEnviar.sitios = this.props.drives_selected
                if (this.props.drives_selected.length === 1) {
                    objEnviar.articulos = this.props.modo === 'uno' ? [this.props.producto_selected.articulo_id] : this.props.arrArticulos.map(item => item.articulo_id)
                } else {
                    objEnviar.articulos = this.props.arrArticulos.map(item => item.id)
                }

                objEnviar.incremento_eventualidad = null
                if (state.mostrarPromocion) {
                    objEnviar.incremento_eventualidad = {};
                    objEnviar.incremento_eventualidad.valor = values.incremento_eventualidad
                    objEnviar.incremento_eventualidad.fecha_inicial = moment(new Date(values.rango_incremento[0])).utcOffset(0, false).format("DD/MM/YYYY")
                    objEnviar.incremento_eventualidad.fecha_vencimiento = moment(new Date(values.rango_incremento[1])).utcOffset(0, false).format("DD/MM/YYYY")
                }
                objEnviar.demanda_diaria = []
                if (state.mostrarNuevo) {
                    objEnviar.demanda_diaria.push(
                        values.dia1, values.dia2, values.dia3, values.dia4, values.dia5, values.dia6,
                        values.dia7, values.dia8, values.dia9, values.dia10, values.dia11, values.dia12,
                        values.dia13, values.dia14, values.dia15, values.dia16, values.dia17, values.dia18,
                        values.dia19, values.dia20, values.dia21
                    )
                }

                state.bloquearBotones = true;
                state.cargando = true;
                this.setState(state, () => {
                    SitiosRequest.EditarEstatusProductos(objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false
                            state.mostrarPromocion = false
                            state.mostrarNuevo = false
                            this.props.form.resetFields();
                            this.setState(state, this.props.esconderModal(true, response.data))
                            if (response.data
                                && response.data.articulos_no_disponibles
                                && response.data.articulos_no_disponibles.length > 0) {
                                openNotification(
                                    "Se ha editado el estatus de los artículos con errores.",
                                    "Estatus editado con errores",
                                    false
                                )
                            } else {
                                openNotification(
                                    "Se ha editado el estatus de los artículos correctamente.",
                                    "Estatus editado correctamente",
                                    true
                                )
                            }
                        })
                        .catch(err => {
                            let errorMessage = 
                                err.response.data
                                && err.response.data.articulos_no_disponibles
                                && err.response.data.articulos_no_disponibles.length > 0
                                    ? 'Modelo de pedido no configurado para el sitio.'
                                    : 'No se ha podido editar el estatus.'
                            this.setState({ bloquearBotones: false, cargando: false })
                            openNotification(
                                errorMessage,
                                "Error al editar el estatus",
                                false
                            )
                        })
                })
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title={"Edición de estatus de artículos"}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={"40%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-estatus-productos"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo !== "ver" ? 'btnVerCrearGuardar' : 'display-none'}
                                key="submit"
                                id="boton-guardar-form-estatus-productos"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label={"Estatus"}
                                        colon
                                    >
                                        {getFieldDecorator('estatus', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione un estatus.' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.estatus : null
                                            )
                                        })(
                                            <Select
                                                id="select-estatus-form-productos"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                onChange={this.handleChangeEstatus}
                                                allowClear
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrEstatus.length > 0 &&
                                                    this.state.arrEstatus.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.state.mostrarPromocion ? '' : 'display-none'} span={12}>
                                    <Form.Item
                                        label={"% de incremento por eventualidad"}
                                        colon={true}>
                                        {getFieldDecorator('incremento_eventualidad', {
                                            rules: [{ required: this.state.mostrarPromocion ? true : false, message: 'Por favor, seleccione incremento por eventualidad.' }],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.incremento_eventualidad !== null ? this.props.producto_selected.incremento_eventualidad.valor : null : null
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-incremento-form-productos"
                                                showSearch
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrPorcentajes.length > 0 &&
                                                    this.state.arrPorcentajes.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.state.mostrarPromocion ? '' : 'display-none'} span={12}>
                                    <Form.Item
                                        label={"Rango de fecha para incremento"}
                                        colon={true}>
                                        {getFieldDecorator('rango_incremento', {
                                            rules: [{ required: this.state.mostrarPromocion ? true : false, message: 'Por favor, seleccione fecha para incremento.' }],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.incremento_eventualidad !== null ? [moment(this.props.producto_selected.incremento_eventualidad.fecha_inicial, dateFormatRange), moment(this.props.producto_selected.incremento_eventualidad.fecha_vencimiento, dateFormatRange)] : null : null
                                            )
                                        })(
                                            <RangePicker
                                                width="100%"
                                                id="range-incremento-form-productos"
                                                format={dateFormat}
                                                placeholder={["Fecha Inicio", "Fecha Fin"]}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row className={this.state.mostrarNuevo ? '' : 'display-none'} gutter={6}>
                                <Col className={this.state.mostrarNuevo ? '' : 'display-none'} span={6}>
                                    <Form.Item
                                        label={"Día 1"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia1', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[0].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-1-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.state.mostrarNuevo ? '' : 'display-none'} span={6}>
                                    <Form.Item
                                        label={"Día 2"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia2', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[1].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-2-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.state.mostrarNuevo ? '' : 'display-none'} span={6}>
                                    <Form.Item
                                        label={"Día 3"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia3', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[2].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-3-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.state.mostrarNuevo ? '' : 'display-none'} span={6}>
                                    <Form.Item
                                        label={"Día 4"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia4', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[3].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-4-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 5"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia5', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[4].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-5-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 6"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia6', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[5].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-6-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 7"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia7', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[6].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-7-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 8"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia8', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[7].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-8-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 9"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia9', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[8].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-9-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 10"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia10', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[9].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-10-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 11"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia11', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[10].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-11-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 12"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia12', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[11].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-12-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 13"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia13', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[12].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-13-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 14"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia14', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[13].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-14-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 15"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia15', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[14].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-15-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 16"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia16', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[15].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-16-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 17"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia17', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[16].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-17-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 18"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia18', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[17].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-18-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 19"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia19', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[18].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-19-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 20"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia20', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[19].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-20-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item
                                        label={"Día 21"}
                                        colon={true}
                                    >
                                        {getFieldDecorator('dia21', {
                                            rules: [
                                                { required: this.state.mostrarNuevo ? true : false, message: 'Ingrese cantidad' },
                                            ],
                                            initialValue: (
                                                (this.props.producto_selected !== undefined && this.props.producto_selected !== null) ? this.props.producto_selected.demanda_diaria.length ? this.props.producto_selected.demanda_diaria[20].cantidad : null : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-dia-21-form-productos"
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                max={99}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormEstatusProductos);